import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartdate',
})
export class SmartDatePipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }
  transform(
    value: Date | string | number | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string
  ): any {
    return super.transform(
      this.normalizeFormat(value),
      format,
      timezone,
      locale
    );
  }

  normalizeFormat(value: any): any {
    const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/;
    if (regex.test(value)) {
      return value.toString().replace(' ', 'T');
    }
    return value;
  }
}
